import { Routes } from '@angular/router';
import { provideModuleStore } from '@app/store/module';
import { provideModulesStore } from '@app/store/modules';
import { provideMediaStore } from '@app/store/media';
import { provideUploadStore } from '@app/store/upload';
import { provideLessonStore } from '@app/store/lesson';
import { provideLessonsStore } from '@app/store/lessons';
import { provideQuizStore } from '@app/store/quiz';
import { provideQuizzesStore } from '@app/store/quizzes';
import { provideQuizQuestionsStore } from '@app/store/quiz-questions';
import { provideQuizQuestionStore } from '@app/store/quiz-question';
import { provideReflectionStore } from '@app/store/reflection';
import { provideReflectionsStore } from '@app/store/reflections';
import { ModalComponent } from '@shared/components';
import { SelectModuleComponent } from './select-module/select-module.component';
import { CreateModuleComponent } from './select-module/create-module/create-module.component';
import { SelectMediaComponent } from './select-media/select/select-media.component';
import { SelectMediaTypeComponent } from './select-media/select-type/select-type.component';
import { UploadMediaComponent } from './select-media/upload/upload-media.component';
import { SelectItemComponent } from './select-item/select-item.component';
import { CreateLessonComponent } from './select-item/create-lesson/create-lesson.component';
import { CreateQuizComponent } from './select-item/create-quiz/create-quiz.component';
import { CreateReflectionComponent } from './select-item/create-reflection/create-reflection.component';
import { AddQuestionComponent } from './add-question/add-question.component';

export const dialogRoutes: Routes = [
    {
        path: 'select-module',
        component: ModalComponent,
        outlet: 'dialog',

        providers: [...provideModulesStore(), ...provideModuleStore()],
        children: [
            { path: '', component: SelectModuleComponent },
            { path: 'create', component: CreateModuleComponent },
        ],
    },
    {
        path: 'select-media',
        component: ModalComponent,
        outlet: 'dialog',

        providers: [...provideMediaStore(), ...provideUploadStore()],
        children: [
            { path: '', component: SelectMediaComponent },
            { path: 'select-type', component: SelectMediaTypeComponent },
            { path: 'upload', component: UploadMediaComponent },
            { path: 'upload/:type', component: UploadMediaComponent },
        ],
    },
    {
        path: 'select-item',
        component: ModalComponent,
        outlet: 'dialog',

        providers: [
            ...provideLessonsStore(),
            ...provideQuizzesStore(),
            ...provideReflectionsStore(),
            ...provideLessonStore(),
            ...provideQuizStore(),
            ...provideReflectionStore(),
        ],
        children: [
            { path: '', component: SelectItemComponent },
            { path: 'create-lesson', component: CreateLessonComponent },
            { path: 'create-quiz', component: CreateQuizComponent },
            { path: 'create-reflection', component: CreateReflectionComponent },
        ],
    },
    {
        path: 'select-media',
        component: ModalComponent,
        outlet: 'subdialog',

        providers: [...provideMediaStore(), ...provideUploadStore()],
        children: [
            { path: '', component: SelectMediaComponent },
            { path: 'select-type', component: SelectMediaTypeComponent },
            { path: 'upload', component: UploadMediaComponent },
            { path: 'upload/:type', component: UploadMediaComponent },
        ],
    },
    {
        path: 'add-question',
        component: ModalComponent,
        outlet: 'dialog',

        providers: [...provideQuizQuestionsStore(), ...provideQuizQuestionStore()],
        children: [{ path: '', component: AddQuestionComponent }],
    },
];
